/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, {css} from 'styled-components';
import Colors from 'constants/Colors';
import PropTypes from 'prop-types';
import {mediaHelper} from "../../utils/src";
import Label from 'components/Form/Label';
import {FontWeight} from 'components/Text';
import Text, {FiraSansBold} from 'components/Text/Text';

const propTypes = {
  isActive: PropTypes.bool,
};

const defaultProps = {
  isActive: false,
}


export const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 0;
  margin: 0px 20px;
  color:${Colors.GRAY[0]};
  ${FiraSansBold}

  ${Text}{
    ${FiraSansBold}
    color:${Colors.GRAY[6]}
  }
  
  ${mediaHelper.sm`
    padding: 10px 0px 0px 0px;
    margin: 0px 0px 0px 10px;
  `}
`;

export const LayoutCircle = styled.div`
  height: 30px;
  width: 30px;
  border-radius: 50%;
  display: flex;
  flex-direction: row;
  justify-content:center;
  align-items: center;
  cursor: pointer;
  
  ${({ isActive }) =>
    isActive
      ? css`
      border: 1px solid ${Colors.GRAY[5]};
      background-color: ${Colors.BLUE};
      color: ${Colors.WHITE}
      box-shadow: 0px 3px 4px -2px rgba(0,0,0,0.75);
    `
      : ` border: 1px solid ${Colors.BLUE};
      background-color: ${Colors.WHITE};
      color: ${Colors.GRAY[6]};
    `
  }
  
  ${mediaHelper.sm`
    height: 35px;
    width: 35px;
  `}
`;

export const Section = styled.div`
  display:flex;
  flex-direction:row;
  align-items: center;
  width: auto;
  
  ${mediaHelper.sm`
    width:33%;
  `}
`;

export const Spacer = styled.div`
  border: 1px solid ${Colors.GRAY[3]};
  height: 0;
  max-height: 0;
  width: 101%;
  align-self: center;
`;

export const Label1 = styled(Label)`
  display: block;
  color: ${Colors.GRAY[2]};
  font-weight: ${FontWeight.Bold};
  font-size: 12px;
  
  ${mediaHelper.sm`
    font-size: 14px;
  `}
`;

export const VerticalGapContent = styled.div`
  padding: 10px 0 0;
`;

export const Text1 = styled.text`
  display: block;
  color: ${Colors.GRAY[6]};
  font-weight: ${FontWeight.SemiBold};
  font-size: 14px;
  margin-bottom: 5px;
  
  ${mediaHelper.sm`
    font-size: 16px;
  `}
`;